import { AxiosInstance } from 'axios';
import { ApiResponse } from 'upstream-shared/models';

export class AuthApiClient {
  constructor(readonly axios: AxiosInstance) {}

  async sendLoginEmail(request: {
    email: string;
    redirectTo?: string;
  }): Promise<ApiResponse> {
    return this.axios.post<ApiResponse>('/auth/email', request);
  }

  async login(token: string): Promise<ApiResponse> {
    return this.axios.post<ApiResponse>('/auth/login', { token });
  }

  async logout(): Promise<ApiResponse> {
    return this.axios.post<ApiResponse>('/auth/logout');
  }

  async deleteMe(): Promise<ApiResponse> {
    return this.axios.delete<ApiResponse>('/auth/me');
  }

  async getTerms(): Promise<{ termsAccepted: boolean | null; termsAcceptedAt: string | null }> {
    const { data } = await this.axios.get('/auth/get-terms');
    return data;
  }

  async acceptTerms(): Promise<void> {
    return this.axios.post('/auth/accept-terms');
  }
}
